import {AnimUtils} from "../utils/AnimUtils";
import {gsap} from "gsap";
import {GameUtils} from "../utils/GameUtils";
import {GameConfig} from "../GameConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class BattleTank extends PIXI.Container {
    private _spine: PIXI.spine.Spine;
    private _defScale: number = 0.6
    private _defPosY: number = 80;
    private readonly _side: string;
    private readonly _defPosX: number;

    constructor(whichSide: string) {
        super();
        this._side = whichSide;
        this.name = this._side + "Tank";
        this._defPosX = this.isLeft() ? -400 : 1120;
        this.init();
    }

    public moveTank(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            (): void => {
                this._spine.visible = true;
                this._spine.state.setAnimation(0, "move_front", true);

                Logger.logDev(this._side, "tank started moving at", GameUtils.getTimeStamp());
            },
            gsap.to(this.position, {
                x: this.isLeft() ? 160 : 560,
                duration: GameConfig.tanksMoveDuration
            })
        ]);

        tl.to(this, {
            duration: AnimUtils.getSpineDuration(this._spine, "turn"),
            onStart: (): void => {
                this._spine.state.setAnimation(0, "turn", false);
            }
        });

        tl.add([
            (): void => {
                this._spine.state.setAnimation(0, "move_back", true);
            },
            gsap.to(this.position, {
                x: this._defPosX,
                duration: GameConfig.tanksMoveDuration
            })
        ]);

        return tl;
    }

    public toggleDisplay(show: boolean): void {
        this.visible = show;
    }

    private isLeft(): boolean {
        return this._side === "left";
    }

    private init(): void {
        this.createTank();
    }

    private createTank(): void {
        this._spine = AnimUtils.createNewSpine({
            path: "tankSpine",
            pos: new PIXI.Point(0, 0),
            initShow: true
        });

        this.position.set(this._defPosX, this._defPosY);
        this._spine.scale.set(this.isLeft() ? -(this._defScale) : this._defScale, this._defScale);
        this.addChild(this._spine);
    }
}